import { createSlice } from '@reduxjs/toolkit';
import { featuresApi } from 'api/features-api';
import { RootState } from 'store';

export type FeaturesSliceType = {
  mining: boolean | null;
  colo: boolean | null;
  loaded: boolean;
};

// `mining`/`colo` stay `null` until the GET features response resolves — the mining guard rule
// (Plan 06 §Key contracts) is `features.mining !== false`, so "not yet loaded" reads as visible,
// keeping mining orgs' UI bit-identical before/after this fetch settles.
export const initialState: FeaturesSliceType = {
  mining: null,
  colo: null,
  loaded: false,
};

const slice = createSlice({
  name: 'features',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(featuresApi.endpoints.getFeatures.matchFulfilled, (state, action) => {
      state.mining = action.payload.mining;
      state.colo = action.payload.colo;
      state.loaded = true;
    });
  },
});

export default slice.reducer;

// selectors
export const featuresSelector = (state: RootState) => state.features;
export const featuresLoadedSelector = (state: RootState) => state.features.loaded;

// Guard rule (Plan 06 §Key contracts): mining defaults visible until proven otherwise (`null`
// before the fetch resolves, or `true` once resolved, both keep mining UI showing); only an
// explicit `false` hides it.
export const miningEnabledSelector = (state: RootState) => state.features.mining !== false;

// Colo surfaces are opt-in: only render once the flag has explicitly resolved to `true`.
export const coloEnabledSelector = (state: RootState) => state.features.colo === true;
